<template>
  <div v-if="product">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>采购单管理</el-breadcrumb-item>
      <el-breadcrumb-item>采购单列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel">
      <el-page-header @back="$router.go(-1)" content="采购单详情">
      </el-page-header>
      <el-descriptions border title="" size="small" class="m-b-10">
        <el-descriptions-item label="业务类型">{{
          product.business_type
        }}</el-descriptions-item>
        <el-descriptions-item label="发票号">
          <span class="font-12" style="position: relative; top: 1px">{{
            product.invoice_number
          }}</span>
          <el-link
            v-if="product.receipt"
            :href="product.receipt.path"
            target="_blank"
            type="primary"
            class="font-12 ml-5"
            :underline="false"
            >查看</el-link
          >
        </el-descriptions-item>
        <el-descriptions-item label="订单号">{{
          product.number
        }}</el-descriptions-item>
        <el-descriptions-item label="入库单号">
          {{ product.stockin_number }}
        </el-descriptions-item>
        <el-descriptions-item label="入库日期">
          {{ product.stock_time }}
        </el-descriptions-item>
        <el-descriptions-item label="仓库">
          {{ product.stockroom_name }}
        </el-descriptions-item>
        <el-descriptions-item label="入库类别">
          {{ product.stockin_category }}
        </el-descriptions-item>
        <el-descriptions-item label="部门">
          {{ product.department }}
        </el-descriptions-item>
        <el-descriptions-item label="业务员">
          {{ product.saler }}
        </el-descriptions-item>
        <el-descriptions-item label="采购类型">{{
          product.purchase_category
        }}</el-descriptions-item>
        <el-descriptions-item label="供货单位">
          {{ product.supplier }}
        </el-descriptions-item>
        <el-descriptions-item label="创建时间">{{
          $time(product.created_at).format('YYYY-MM-DD HH:mm')
        }}</el-descriptions-item>
        <el-descriptions-item label="结算时间">{{
          product.settle_time
            ? $time(product.settle_time).format('YYYY-MM-DD HH:mm')
            : '-'
        }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag size="mini" type="primary">{{
            PurchaseOrderStatusMap[product.status]
          }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="记账人">
          {{ product.bookkeeper }}
        </el-descriptions-item>
        <el-descriptions-item label="备注">
          {{ product.remark }}
        </el-descriptions-item>
      </el-descriptions>
      <el-popconfirm
        v-if="canEdit"
        v-code="61104"
        title="确认删除该采购单吗？"
        @confirm="handleDelete"
      >
        <el-button
          slot="reference"
          type="danger"
          size="mini"
          class="mr-15"
          plain
          >删除</el-button
        >
      </el-popconfirm>
      <el-button
        v-code="61103"
        type="primary"
        size="mini"
        class="mr-5"
        plain
        @click="editProduct"
        v-if="product.status != 100"
        >编辑</el-button
      >
      <el-popconfirm
        v-code="61107"
        title="确定完成质检吗？"
        @confirm="handleUpdateStatus(2)"
        v-if="product.status == 1"
      >
        <el-button
          slot="reference"
          type="primary"
          size="mini"
          class="mr-5"
          plain
          >完成到货质检</el-button
        >
      </el-popconfirm>

      <el-button
        v-code="61108"
        type="primary"
        size="mini"
        class="mr-5"
        plain
        v-if="product.status == 2"
        @click="
          settlementModel.status = 3
          settlementVisible = true
        "
        >完成入库</el-button
      >
      <el-button
        v-code="61109"
        type="primary"
        size="mini"
        class="mr-5"
        plain
        v-if="product.status == 3"
        @click="
          settlementModel.status = 100
          settlementVisible = true
        "
        >发票结算</el-button
      >
      <el-button
        v-code="61103"
        type="primary"
        size="mini"
        plain
        @click="printOrder"
        >打印</el-button
      >
    </div>

    <div class="panel">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="材料明细" name="tab1">
          <el-table
            border
            :data="product.items"
            :key="randomKey"
            @cell-click="editData"
            show-summary
            :summary-method="getSummaries"
            ref="table"
          >
            <el-table-column
              label="材料分类"
              prop="category"
              align="center"
              min-width="100"
            >
              <template slot-scope="scope">
                <CommodityCategorySelect
                  v-if="scope.row[scope.column.property + 'isShow']"
                  :ref="scope.column.property"
                  v-model="scope.row.category"
                  @blur="handleSaveItem(scope.row, scope.column, scope.$index)"
                ></CommodityCategorySelect>
                <span v-else>{{
                  CommodityCategoryMap.filter(
                    (item) => item.id == scope.row.category
                  )[0].name
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="存货编码"
              prop="code"
              align="center"
              min-width="100"
            >
              <template slot-scope="scope">
                <CommodityCodeSlect
                  v-if="scope.row[scope.column.property + 'isShow']"
                  :ref="scope.column.property"
                  :category="scope.row.category"
                  v-model="scope.row.code"
                  @blur="handleSaveItem(scope.row, scope.column, scope.$index)"
                ></CommodityCodeSlect>
                <span v-else>{{ scope.row.code }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="名称"
              prop="name"
              align="center"
              min-width="100"
            >
              <template slot-scope="scope">
                <!-- <CommodityParamsSelect
                  v-if="scope.row[scope.column.property + 'isShow']"
                  :ref="scope.column.property"
                  table="commodities"
                  :paramName="scope.column.property"
                  :category="scope.row.category"
                  v-model="scope.row.name"
                  @blur="handleSaveItem(scope.row, scope.column, scope.$index)"
                ></CommodityParamsSelect>
                <span v-else>{{ scope.row.name }}</span> -->
                <span class="text-muted">{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="规格"
              prop="specification"
              align="center"
              min-width="100"
            >
              <template slot-scope="scope">
                <!-- <CommodityParamsSelect
                  v-if="scope.row[scope.column.property + 'isShow']"
                  :ref="scope.column.property"
                  table="commodities"
                  :paramName="scope.column.property"
                  :category="scope.row.category"
                  v-model="scope.row.specification"
                  @blur="handleSaveItem(scope.row, scope.column, scope.$index)"
                ></CommodityParamsSelect>
                <span v-else>{{ scope.row.specification }}</span> -->
                <span class="text-muted">{{ scope.row.specification }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="型号或倒角"
              prop="model_number"
              align="center"
              min-width="100"
            >
              <template slot-scope="scope">
                <!-- <CommodityParamsSelect
                  v-if="scope.row[scope.column.property + 'isShow']"
                  :ref="scope.column.property"
                  table="commodities"
                  :paramName="scope.column.property"
                  :category="scope.row.category"
                  v-model="scope.row.model_number"
                  @blur="handleSaveItem(scope.row, scope.column, scope.$index)"
                ></CommodityParamsSelect>
                <span v-else>{{ scope.row.model_number }}</span> -->
                <span class="text-muted">{{ scope.row.model_number }}</span>
              </template>
            </el-table-column>
            <template v-if="normalCategory">
              <el-table-column
                label="计量单位"
                prop="unit"
                align="center"
                min-width="100"
              >
                <template slot-scope="scope">
                  <!-- <CommodityParamsSelect
                  v-if="scope.row[scope.column.property + 'isShow']"
                  :ref="scope.column.property"
                  table="commodities"
                  :paramName="scope.column.property"
                  v-model="scope.row.unit"
                  @blur="handleSaveItem(scope.row, scope.column, scope.$index)"
                ></CommodityParamsSelect>
                <span v-else>{{ scope.row.unit }}</span> -->
                  <span class="text-muted">{{ scope.row.unit }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="数量"
                prop="number"
                align="center"
                min-width="100"
              >
                <template slot-scope="scope">
                  <el-input-number
                    :controls="false"
                    v-if="scope.row[scope.column.property + 'isShow']"
                    :ref="scope.column.property"
                    v-model.number="scope.row.number"
                    @blur="
                      handleSaveItem(scope.row, scope.column, scope.$index)
                    "
                  ></el-input-number>
                  <span v-else>{{ scope.row.number }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="单价"
                prop="no_tax_price"
                align="right"
                min-width="100"
              >
                <template slot-scope="scope">
                  <!-- <el-input-number
                  :precision="2"
                  v-if="scope.row[scope.column.property + 'isShow']"
                  :ref="scope.column.property"
                  v-model.number="scope.row.no_tax_price"
                  @blur="handleSaveItem(scope.row, scope.column, scope.$index)"
                  :controls="false"
                ></el-input-number>
                <span v-else>{{ scope.row.no_tax_price.toFixed(2) }}</span> -->
                  <span class="text-muted">{{
                    scope.row.no_tax_price.toFixed(2)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="含税单价"
                prop="tax_price"
                align="right"
                min-width="100"
              >
                <template slot-scope="scope">
                  <el-input-number
                    :precision="2"
                    v-if="scope.row[scope.column.property + 'isShow']"
                    :ref="scope.column.property"
                    v-model.number="scope.row.tax_price"
                    @blur="
                      handleSaveItem(scope.row, scope.column, scope.$index)
                    "
                    :controls="false"
                  ></el-input-number>
                  <span v-else>{{ scope.row.tax_price.toFixed(2) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="税率"
                prop="tax_rate"
                align="right"
                min-width="100"
              >
                <template slot-scope="scope">
                  <CommodityParamsSelect
                    v-if="scope.row[scope.column.property + 'isShow']"
                    :ref="scope.column.property"
                    :paramName="scope.column.property"
                    table="purchase_order_items"
                    v-model="scope.row.tax_rate"
                    @blur="
                      handleSaveItem(scope.row, scope.column, scope.$index)
                    "
                  ></CommodityParamsSelect>
                  <span v-else>{{ scope.row.tax_rate.toFixed(2) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="税额" align="right" prop="total_tax">
                <template slot-scope="scope">
                  <span class="text-muted">{{
                    scope.row.total_tax.toFixed(2)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="金额"
                align="right"
                prop="total_no_tax_price"
              >
                <template slot-scope="scope">
                  <span class="text-muted">{{
                    scope.row.total_no_tax_price.toFixed(2)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="价税合计"
                align="right"
                prop="total_price"
              >
                <template slot-scope="scope">
                  <span class="text-muted">{{
                    scope.row.total_price.toFixed(2)
                  }}</span>
                </template>
              </el-table-column>
            </template>

            <el-table-column
              v-else
              label="金额"
              align="right"
              prop="total_no_tax_price"
            >
              <template slot-scope="scope">
                <el-input-number
                  :precision="2"
                  v-if="scope.row[scope.column.property + 'isShow']"
                  :ref="scope.column.property"
                  v-model.number="scope.row.total_no_tax_price"
                  @blur="handleSaveItem(scope.row, scope.column, scope.$index)"
                  :controls="false"
                ></el-input-number>
                <span v-else>{{
                  scope.row.total_no_tax_price.toFixed(2)
                }}</span>
              </template>
            </el-table-column>

            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-popconfirm
                  v-if="canEdit"
                  v-code="61106"
                  title="确定删除该材料吗？"
                  @confirm="handleItemDelete(scope.row, scope.$index)"
                >
                  <el-link
                    slot="reference"
                    type="danger"
                    class="font-12"
                    :underline="false"
                    >删除</el-link
                  >
                </el-popconfirm>
                <el-popconfirm
                  v-if="scope.row.status == 1"
                  v-code="51301"
                  title="确认更新此采购单的材料明细吗？"
                  @confirm="handleConfirm(scope.row, scope.$index)"
                >
                  <el-link
                    slot="reference"
                    type="primary"
                    class="font-12 ml-5"
                    :underline="false"
                    >确认</el-link
                  >
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
          <el-button
            v-if="canEdit"
            v-code="61106"
            type="primary"
            class="mt-10"
            size="mini"
            @click="handleAddItem"
            >添加材料</el-button
          >
        </el-tab-pane>
        <el-tab-pane label="操作日志" name="tab2">
          <el-table :data="product.logs" border>
            <el-table-column label="操作人" prop="user_name"></el-table-column>
            <el-table-column label="操作类型" prop="category">
              <template slot-scope="scope">
                {{ PurchaseOrderLogMap[scope.row.category] }}
              </template>
            </el-table-column>
            <el-table-column label="操作内容" prop="content">
              <template slot-scope="scope">
                <div v-html="scope.row.content"></div>
                <div class="demo-image__preview">
                  <el-image
                    v-for="url in scope.row.imgs"
                    :key="url"
                    style="width: 30px; height: 30px; margin-right: 10px"
                    :src="url"
                    :preview-src-list="scope.row.imgs"
                  >
                  </el-image>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作时间" align="center">
              <template slot-scope="scope">
                {{ $time(scope.row.created_at).format('YYYY-MM-DD HH:mm') }}
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <EditFormer
      :model="model"
      :show.sync="formerVisible"
      @callback="updatedCallback"
    ></EditFormer>

    <SettlementFormer
      :model="settlementModel"
      :show.sync="settlementVisible"
      @callback="updatedCallback"
    ></SettlementFormer>

    <OrderPrint :order="product" ref="print" :key="randomKey"></OrderPrint>
  </div>
</template>

<script>
import {
  purchaseOrderDetail,
  purchaseOrderDelete,
  purchaseOrderItemUpdate,
  purchaseOrderItemDelete,
  purchaseOrderItemConfirm,
  purchaseOrderUpdateStatus,
} from '@/service/getData'
import EditFormer from './editor'
import SettlementFormer from './settlementFormer.vue'
import {
  CommodityCategoryMap,
  PurchaseOrderStatusMap,
  PurchaseOrderLogMap,
} from '../../../config/global'
import CommodityCategorySelect from '../../../components/select/commodity_category.vue'
import CommodityParamsSelect from './CommodityParamsSelect.vue'
import { hasAuth } from '../../../permission'
import CommodityCodeSlect from './CommodityCodeSlect.vue'
import OrderPrint from './OrderPrint.vue'

import Vue from 'vue'
import Print from '@/plugins/jquery.PrintArea.js'
Vue.use(Print)

export default {
  components: {
    EditFormer,
    CommodityCategorySelect,
    CommodityParamsSelect,
    SettlementFormer,
    CommodityCodeSlect,
    OrderPrint,
  },
  data() {
    return {
      CommodityCategoryMap,
      settlementVisible: false,
      settlementModel: {
        id: parseInt(this.$route.params.id),
        status: 0,
        imgs: [],
        invoice_number: '',
        stockin_number: '',
        stock_time: this.$time(new Date()).format('YYYY-MM-DD'),
        stockroom_name: '',
        stockin_category: '',
        remark: '',
      },
      PurchaseOrderStatusMap,
      PurchaseOrderLogMap,
      activeTab: 'tab1',
      product: null,
      formerVisible: false,
      model: {},
      randomKey: Math.random(),
    }
  },
  computed: {
    canEdit() {
      return (
        this.product &&
        (this.product.status < 3 ||
          this.$time(this.product.created_at).format('YYYY-MM') ==
            this.$time(new Date()).format('YYYY-MM'))
      )
    },
    normalCategory() {
      return this.product.belong_month != 2
    },
  },
  created() {
    this.getData()
  },
  methods: {
    printOrder() {
      this.$print(this.$refs.print)
    },

    async getData() {
      let res = await purchaseOrderDetail(this.$route.params.id)
      if (res.status == 0) {
        this.product = res.data
      }
    },
    editProduct() {
      this.model = this.clone(this.product)
      this.formerVisible = true
    },
    async handleDelete() {
      let res = await purchaseOrderDelete(this.product.id)
      if (res.code == 0) {
        this.$router.go(-1)
      }
    },
    updatedCallback() {
      this.getData()
    },
    handleAddItem() {
      this.product.items.push({
        category: '',
        categoryisShow: true,
        name: '',
        code: '',
        specification: '',
        model_number: '',
        unit: '',
        purchase_order_id: this.product.id,
        number: 0,
        no_tax_price: 0,
        tax_price: 0,
        tax_rate: 0,
        total_price: 0,
        total_tax: 0,
        total_no_tax_price: 0,
      })
      this.$nextTick(() => {
        this.$refs['category'].$refs.itemSelect.focus()
      })
    },
    editData(row, column) {
      if (
        !hasAuth(61106) ||
        (row.status == 0 && this.product.status > 2) ||
        !column.property ||
        row[column.property + 'isShow']
      ) {
        return
      }

      if (
        this.product.items.filter(
          (item) =>
            item.categoryisShow ||
            // item.nameisShow ||
            item.codeisShow ||
            // item.specificationisShow ||
            // item.model_numberisShow ||
            // item.unitisShow ||
            item.tax_rateisShow
        ).length > 0
      ) {
        return
      }

      row[column.property + 'isShow'] = true
      this.refreshTable()
      this.$nextTick(() => {
        if (
          [
            'category',
            // 'name',
            'code',
            // 'specification',
            // 'model_number',
            // 'unit',
            'tax_rate',
          ].includes(column.property)
        ) {
          this.$refs[column.property].$refs.itemSelect.focus()
        } else {
          this.$refs[column.property] && this.$refs[column.property].focus()
        }
      })
    },
    refreshTable() {
      this.randomKey = Math.random()
    },
    async handleSaveItem(row, column, index) {
      if (column.property == 'category' && !row.category) {
        this.product.items.splice(index, 1)
        return
      }

      row.tax_rate = parseFloat(row.tax_rate)
      let res = await purchaseOrderItemUpdate(row)
      if (res.code == 0) {
        this.product.items[index] = res.data
      } else {
        this.getData()
      }
      row[column.property + 'isShow'] = false
      this.refreshTable()
    },
    async handleUpdateStatus(status = 0) {
      let res = await purchaseOrderUpdateStatus({
        id: this.product.id,
        status: status,
      })
      if (res.code == 0) {
        this.product = res.data
      }
    },
    async handleItemDelete(item, index) {
      let res = await purchaseOrderItemDelete(item.id)
      if (res.code == 0) {
        this.product.items.splice(index, 1)
      }
    },
    async handleConfirm(item, index) {
      let res = await purchaseOrderItemConfirm(item.id)
      if (res.code == 0) {
        this.$message.success('操作成功！')
        this.getData()
      }
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }

        if (
          ['total_tax', 'total_no_tax_price', 'total_price'].includes(
            column.property
          )
        ) {
          const values = data.map((item) => Number(item[column.property]))
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)

            sums[index] = sums[index].toFixed(2)
          } else {
            sums[index] = ''
          }
        }
      })

      return sums
    },
  },
}
</script>

<style scoped>
.title {
  font-size: 16px;
  font-weight: 400;
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
}

.el-table__cell .el-input-number {
  width: 100%;
}
/deep/.el-table__cell .el-input-number .el-input__inner {
  padding: 0 !important;
}
</style>